import React from "react";
import services from "../../services";
import { withRouter, Route } from "react-router-dom";
import Lang from "../../lang";
import SearchFilter from "../filters/SearchFilter";
import TitleBar from "../common/title_bar";
import $ from "jquery";
import TlkTable from "../tlelrik/table/tlkTable";
import ContaTabsContainer from "../ContaModule/Tabs/TabsContainer";
import queryString from "query-string";
import MovementListing from "./MovemenListing";
import MovementTabs from "./Tabs/MovementTabs"
import AccountListing from "./AccountListing";
import { Button } from "@progress/kendo-react-buttons";
import moment from "moment";
import RegistoTable from "../RegistoModule/Tabs/RegistoTable";

// Entidade
// Entreposto
// Tipo de instalação
// Número de instalação vínica
// Instalação vínica
// Estado
// Saldo total
// Saldo Granel
// Saldo Apto
// Saldo engarrafado
const dateFormatNoTime = "YYYY-MM-DD";
const dateFormat = "YYYY-MM-DD HH:mm:ss";
const columnKeyMap = {
    localArmazenagem: "Local de Armazenagem",
    instalacaoVinica: "Instalação Vínica",
    nomeEntidade: "Entidade",
    //codEntrFiscal: "Codigo Entreposto fiscal",
    saldoGranel: "Granel Não Certificado",
    saldoGranelApto: "Granel Apto",
    saldoIndispGranel: "Indisp a Granel",
    saldoIndispEngarrafado: "Indisp Engarrafado",
    saldoProdutoAcabado: "Produto Acabado",
    estado: "Estado",
    //idInstalacaoVinica: "Número de instalação",
};

const groupfield = [
    //{ field: "Nº Parcela IVDP" },
    //{ field: "Entreposto" },
    // { field: 'Concelho' },
    // { field: 'Freguesia' },
];

const filters = {
    Tabs: {
        NIF: [
            {
                key: "nif",
                displayKey: "procurar por nif",
                inputType: "text",
            },
        ],
        // Parcela: [
        //   {
        //     key: 'pontuacao',
        //     displayKey: "pontuação",
        //     inputType: "text"
        //   },
        //   {
        //     key: 'numparc',
        //     displayKey: "Nº Parcela IVDP",
        //     inputType: "text"
        //   },
        //   {
        //     key: 'numparant',
        //     displayKey: " Nº Parcela CD",
        //     inputType: "text"
        //   },
        // ],
        // Geocódigo: [
        //   {
        //     key: 'countryName',
        //     displayKey: "Concelho",
        //     inputType: "text"
        //   },
        //   {
        //     key: 'parishName',
        //     displayKey: "Freguesia",
        //     inputType: "text"
        //   },
        //   {
        //     key: 'geocod',
        //     displayKey: "Geocódigo",
        //     inputType: "text"
        //   }
        // ],
        // "Ficha de exploração": [
        //   {
        //     key: 'anoplantacao',
        //     displayKey: "Ano de plantação",
        //     inputType: "text"
        //   }
        // ]
    },
    checkbox: [
        // {
        //   key: 'Explorer',
        //   displayKey: "Exploradora",
        //   inputType: "radio"
        // },
        // {
        //   key: 'Owner',
        //   displayKey: "Proprietária",
        //   inputType: "radio"
        // },
        // {
        //   key: 'Explorer/Owner',
        //   displayKey: "Ambos",
        //   inputType: "radio"
        // },
    ],
};

class DashBoardFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            entityGrid: "",
            showSearchMsg: false,
            totalcount: 0,
            clickLimparFilter: false,
            entity_list_object: {},
            customfilters: {},
            tlkfilter: {},
            date: new Date(),
        };
    }

    componentDidMount() {
        $(window).scrollTop(0);
    }

    componentDidUpdate(proProp) {
        if (proProp.date !== this.props.date) {
            this.setState({
                data: [],
                entityGrid: "",
                showSearchMsg: false,
                totalcount: 0,
                clickLimparFilter: false,
                entity_list_object: {},
                customfilters: {},
                tlkfilter: {},
                date: new Date(),
            });
        }
    }

    getLangFile = () => {
        Lang.getJSON.getJSONFile();
    };

    handleFilter = (data) => {
        console.log("fffffffff", data);
    };

    createTable = async () => {
        // const columnList = Object.keys(columnKeyMap).map((key) => ({
        //     field: columnKeyMap[key],
        //     columnMenuType: "checkbox",
        // }));

        var columnList = [];

        Object.keys(columnKeyMap).forEach(e => {
            if(e == "saldoGranel" || e == "saldoGranelApto" || e == "saldoIndispGranel" || e == "saldoIndispEngarrafado" || e == "saldoProdutoAcabado"){
                columnList.push({field: columnKeyMap[e], columnMenuType: "number"});
            }
            else{
                columnList.push({field: columnKeyMap[e], columnMenuType: "checkbox"});
            }
        });

        console.log("COLUNAS");
        console.log(columnList);
        const actionbuttons = {
            CommonRedirection: "Detalhes da instalação do vinho",
        };
        const entityGrid = (
            <TlkTable
                date={new Date()}
                // sendDatatoTlkTable={(filter) => this.sendDataToGrid(filter)}
                list={this.state.data}
                modulename={"Conta Corrente"}
                // notAction={false}
                actionbuttons={actionbuttons}
                // notGroup={true}
                
                //actionColWidth={70}
               
                // actionColWidth={70}
                columnlist={columnList}
                groupfield={groupfield}
                ActionPerform={(action, id) => this.ActionPerform(action, id)}
                // selection={ true }
                // selectionChange={ (e) => this.selectionChange(e) }
            />
        );
        await this.setState({ entityGrid });
    };

    // selectionChange(selection) {
    //   const data = [...this.state.data]
    //   data.some((item, index) => {
    //     if (selection.dataItem.Entidade === item.Entidade) {
    //       data[index].selected = !item.selected;
    //       return true;
    //     }
    //     return false;
    //   });
    //   this.setState({ data }, async () => {
    //     await this.createTable();
    //     const queryParams = queryString.stringify({
    //       entityId: selection.dataItem.Entidade
    //     })
    //     this.props.history.push(`/conta_corrente/tabs_view/account?${queryParams}`);
    //   });
    // }

    getFilters(filters) {
        if (!this.props.match.isExact) {
            this.props.history.push("/conta_corrente");
        }
        this.setState(
            {
                customfilters: filters,
                totalcount: 0,
                clickLimparFilter: false,
                showSearchMsg: false,
                entityGrid: null,
            },
            () => {
                if (
                    filters &&
                    (Object.keys(filters.filters).length > 0 ||
                        Object.keys(filters.filterCheckbox).length > 0)
                ) {
                    this.sendDataToGrid();
                }
            }
        );
    }

    makeAllFilters = () => {
        const customFilters = { ...this.state.customfilters };
        console.log("customFilters -> ", customFilters);
        return {
            Filters: {
                entityNif: +customFilters.filters.nif
                    ? +customFilters.filters.nif
                    : +customFilters.filters.entityIdFilter || null,
                installationNo: customFilters.filters.Installation,
                entityId: 0
            },
            FiltersIn: null,
            FiltersLike: null,
            SortBy: "",
            IsSortTypeDESC: true,
            IsPagination: false,
            Page: 2,
            PageSize: 2,
        };
    };

    sendDataToGrid = async () => {
        let { customfilters } = this.state;
        if (
            customfilters &&
            Object.keys(customfilters.filters).length == 0 &&
            Object.keys(customfilters.filterCheckbox).length == 0
        ) {
            return;
        }
        const filters = this.makeAllFilters();
        const response = await services.apiCall.requestApi(
            "InstalacaoVinica/GetInstalacoesVinicas",
            filters,
            "post"
        );

        if (response && response.length > 0) {
            // const data = response.map((entity, index) => ({
            //   ...Object.keys(columnKeyMap).reduce((acc, key) => {
            //     acc[columnKeyMap[key]] = entity[key]
            //     return acc;
            //   }, {}),
            //   selected: false,
            // }));
            // idInstalacaoVinica1: "Saldo total",
            // idInstalacaoVinica2: "Saldo Granel",
            // idInstalacaoVinica3: "Saldo Apto",
            // idInstalacaoVinica4: "Saldo engarrafado",
            const data = response.map((entity, index) => ({
                ...entity,
                ...Object.keys(columnKeyMap).map((key) => {
                    if (key === "saldoTotal") {
                        let saldoTotal = Number(
                            Number(
                                entity["saldoGranel"]
                                    ? entity["saldoGranel"]
                                    : ""
                            ) +
                                Number(
                                    entity["saldoApto"]
                                        ? entity["saldoApto"]
                                        : ""
                                ) +
                                Number(
                                    entity["saldoEngarrafado"]
                                        ? entity["saldoEngarrafado"]
                                        : ""
                                ) +
                                Number(
                                    entity["comercializado"]
                                        ? entity["comercializado"]
                                        : ""
                                )
                        );
                        entity[columnKeyMap[key]] = services.money.format(
                            saldoTotal.toString()
                        );
                    }
                    else if (key === "dataUltimoMovimento"){
                        entity[columnKeyMap[key]] = moment(
                            entity.dataUltimoMovimento
                        ).format(dateFormat)
                    }
                    else if (
                        key === "saldoGranel" ||
                        key === "saldoGranelApto" ||
                        key === "saldoIndispGranel" ||
                        key === "saldoIndispEngarrafado" ||
                        key === "saldoProdutoAcabado"
                    ) {
                        entity[columnKeyMap[key]] = services.money.format(entity[key]) || "0";
                    } else {
                        entity[columnKeyMap[key]] = entity[key];
                    }
                }),
                selected: false,
            }));
            this.setState(
                {
                    data,
                    showSearchMsg: false,
                    totalcount: window.localStorage.getItem("table_total"),
                },
                () => {
                    console.log("887788 data", this.state.data);
                    this.createTable();
                }
            );
        } else {
            this.setState({ showSearchMsg: true });
        }
    };

    /*  Para realizar a ação com base na seleção da tabela  */
    ActionPerform = async (action, row) => {
        console.log("row in the ", row);
        // TODO: Rohit — Export data from grid
        if (action === "Detalhes da instalação do vinho") {
            // const data = [...this.state.data]
            // data.some((item, index) => {
            //   if (row.Entidade === item.Entidade) {
            //     data[index].selected = !item.selected;
            //     return true;
            //   }
            //   return false;
            // });
            // this.setState({ data }, async () => {
            // await this.createTable();
            console.log("rrrrrrrrrr", row);
            const queryParams = queryString.stringify({
                entityId: row.detalheURLCodEntidade,
                IDInstalacaoVinica: row.detalheURLIDInstalacao
            });
            this.props.history.push(
                `/conta_corrente/tabs_view/account?${queryParams}`
            );
            console.log("he queryParams are 7878", queryParams);
            // });
        }
    };

    backToSearch = () => {
        this.props.history.push("/conta_corrente");
    };

    refreshComponent = () => {
        this.setState({ clickLimparFilter: true });
    };

    /*  Para renderizar o conteúdo html da página   */
    render() {
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        title="Conta Corrente Vínica"
                        refreshComponent={() => this.refreshComponent()}
                        onlyInicioLink={"/conta_corrente"}
                        logo="contacorrente"
                    />
                </div>
                <div className="container-fluid">
                    {this.props.location.pathname === "/conta_corrente" ? (
                        <SearchFilter
                            optionText="Pesquisa por NIF ou nome"
                            installationNumber={true}
                            date={this.state.date}
                            filters={filters}
                            moduleType="Conta"
                            clickLimparFilter={this.state.clickLimparFilter}
                            data={this.state.data}
                            handleFilter={(data) => this.handleFilter(data)}
                            getFilter={(data) => this.getFilters(data)}
                        />
                    ) : (
                        <Button
                            className="k-button mr-2 k-primary btn-ivdp-secondary btn-theme remoove mt-2text-danger"
                            onClick={() => this.backToSearch()}
                        >
                            Voltar à Pesquisa de Entidades
                        </Button>
                    )}
                    {this.props.location.pathname ===
                        "/conta_corrente/movements"
                        && (
                        <Button
                            className="mr-2 btn-ivdp-primary btn-theme k-primary"
                            onClick={() => window.history.back()}
                        >
                            Voltar
                        </Button>
                    )}
                    {this.props.location.pathname ===
                        "/conta_corrente/registoTable"
                        && (
                        <Button
                            className="mr-2 btn-ivdp-primary btn-theme k-primary"
                            onClick={() => window.history.back()}
                        >
                            Voltar
                        </Button>
                    )}

                    <div className="table-section custom-k-grid pt-3">
                        {this.props.match.isExact && (
                            <>
                                {
                                    <div
                                        className={
                                            this.state.data &&
                                            this.state.data.length
                                                ? ""
                                                : "tlkwodata"
                                        }
                                    >
                                        {this.state.totalcount > 0 && (
                                            <h3>
                                                {" "}
                                                A pesquisa retornou{" "}
                                                {this.state.totalcount}{" "}
                                                instalações vínicas
                                            </h3>
                                        )}
                                        <div className="table-responsive">
                                            {this.state.entityGrid}
                                        </div>
                                    </div>
                                }
                                {this.state.totalcount == 0 && (
                                    <div className="searct-found">
                                        <img
                                            className="img-fluid"
                                            src="imgs/data-contacorrente.png"
                                            alt="Pesquisa Contas Correntes Vínicas"
                                        />
                                        {this.state.showSearchMsg ? (
                                            <p className="font-14">
                                                Sem resultados
                                            </p>
                                        ) : (
                                            <h3>
                                               Pesquise uma entidade para apresentação de mais informações
                                            </h3>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    {!this.props.match.isExact && (
                        <Route
                            path={`${this.props.match.path}/tabs_view`}
                            component={ContaTabsContainer}
                        />
                    )}
                    {!this.props.match.isExact && (
                        <Route
                            path={`${this.props.match.path}/movements`}
                            component={MovementListing}
                        ></Route>
                    )}
                    {!this.props.match.isExact && (
                        <Route
                            path={`${this.props.match.path}/accounts_view`}
                            component={AccountListing}
                        />
                    )}
                     {!this.props.match.isExact && (
                        <Route
                            path={`${this.props.match.path}/registoTable`}
                            component={RegistoTable}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(DashBoardFilter);
